export enum CouponTypes {
  referral = 'referral',
  voucher = 'voucher',
  discount = 'discount',
  film = 'film',
  default = 'default',
}
